import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SimpleBar from 'simplebar-react';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { LayoutContextProvider } from '@/styledComponents/render/Layout/context';
import useStyles from './style';
import Menu from './Menu';

const LayoutConnector = ({ children, load }) => {
  const classes = useStyles();

  return (
    <LayoutContextProvider>
      <div className={classes.root}>
        <Menu />
        <main className={classes.wrap}>
          <div className={classes.content}>
            <div
              className={classes.container}
              style={{ visibility: load ? 'hidden' : 'visible' }}
            >
              <SimpleBar className={clsx(classes.scroll, load && 'active')}>
                <Grid classes={{ root: classes.grid }}>{children}</Grid>
              </SimpleBar>
            </div>
          </div>
        </main>
      </div>
    </LayoutContextProvider>
  );
};

const mapStateToProps = state => ({
  userState: state.user,
  olimp: state.olimpic,
  load: state.requests.load,
});

LayoutConnector.propTypes = {
  children: PropTypes.object.isRequired,
  load: PropTypes.bool.isRequired,
  // userState: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(LayoutConnector);
